import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import DirectionsItem from './DirectionsItem';

@propsDecorator({
    itemView: DirectionsItem,
    bindings: {
        '#directionsTemplate': 'collection: $collection',
    },
})
export default class DirectionsView extends Backbone.Epoxy.View {
    initialize(options) {
        this.collection = options.collection;
        this.model = options.parentModel;
        this.directionsTemplate = options.directionsTemplate;
    }
}
